import React, { Component } from "react";
import { connect } from "react-redux";
import Back from "../../assets/Back";
import CheckmarkLight from "../../assets/CheckmarkLight";
import Logo from "../../assets/Logo"; // TODO: Just put this guy in a container component so we don't need to keep importing the logo, dummy!
import Portrait from "../../assets/Portrait";
import SadFace from "../../assets/SadFace";
import Fade from "../common/Fade";
import * as actions from "../../state/actions/onboarding";
import { track } from "../../api/heap";

const contactUrl = `${process.env.REACT_APP_DOMAIN}/contact`;

class ProcessingIdentity extends Component {
  constructor(props) {
    super(props);
    this.state = { approved: null, error: null };
    this.timer = null;
    // We adjust the percentPerTick up or down so that the remaining percentage displayed
    // by the progress bar takes 90 seconds to get to 100%
    this.expectedDuration = 90;
    this.percentPerTick = 1;
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    const {
      percentPerTick,
      expectedDuration,
      props: {
        percentage,
        verifyUser,
        user: { evaluationComplete, shouldEvaluate }
      }
    } = this;
    this.percentPerTick = 1 / (expectedDuration / (100 - percentage));
    this.startTimer();

    if (evaluationComplete) {
      console.log("User already has an evaluation!");
    } else if (shouldEvaluate) {
      console.log("Getting user evaluation!");
      track("ONBOARDING_IDENTITY_STEP_SUBMITTING");
      verifyUser();
    }
  }
  componentDidUpdate(nextProps){
    if (nextProps.user.evaluationComplete) this.handleNext();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.idValid ||
      (nextProps.user && nextProps.user.evaluationComplete)
    ) {
      this.stopTimer();
      this.props.updateVerificationProgress({
        time: 0,
        percentage: 100
      });
    } else if (nextProps.idValid === false) {
      this.stopTimer();
      this.props.updateVerificationProgress({
        time: 0,
        percentage: 100
      });
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  tick = () => {
    console.log("tick");
    if (this.props.time < 1) {
      this.stopTimer();
    }
    this.props.updateVerificationProgress({
      time: this.props.time - 1,
      percentage: this.props.percentage + this.percentPerTick
    });
  };

  startTimer = () => {
    this.props.updateVerificationProgress({
      duration: this.expectedDuration,
      time: this.expectedDuration
    });
    this.timer = setInterval(this.tick, 1000);
  };

  stopTimer = () => {
    clearInterval(this.timer);
  };

  handlePrevious = (tryAgain, isSsn = false) => {
    console.log("processingId handling previous");
    if (tryAgain) {
      this.props.updateStep("verifyId", {
        stepIsComplete: false,
        error: null
      });
      this.props.updateStep("processingId", {
        stepIsComplete: false,
        approved: null,
        error: null
      });
      this.props.setIdValid(null);
      this.props.updateVerificationProgress({
        time: 0,
        percentage: 0
      });
      if (isSsn) {
        this.props.updateStep("personalinformation", {
          stepIsComplete: false,
          approved: null,
          error: null
        });
        this.props.history.push("/personalinformation");
      } else {
        this.props.setIdBack(null);
        this.props.setIdFront(null);
        this.props.previousStep();
      }
    } else {
      this.props.previousStep();
    }
  };

  handleNext = () => {
    console.log("processingId handling next");
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    const {
      step: { stepIsComplete },
      nextStep,
      updateStep,
      user
    } = this.props;

    if (stepIsComplete || user.evaluationComplete) {
      track("ONBOARDING_IDENTITY_STEP_COMPLETE_CONTINUE_CLICKED");
      updateStep("processingId", { error: null });
      nextStep(null, true);
    } else {
      updateStep("processingId", {
        error: "Step is not yet complete"
      });
    }
  };

  renderProcessing = () => {
    const {
      step: { error },
      user: { evaluationComplete },
      idValid
    } = this.props;
    const { approved } = this.state;
    const { handlePrevious, handleNext } = this;

    return (
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
          <div className="stepDescriptionText">
            {idValid || evaluationComplete
              ? "Yay! Looks like it's really you."
              : "This might take a minute"}
          </div>
          <div style={{ maxHeight: 220 }}>
            <div style={{ margin: "0 auto" }}>
              {this.renderProgressCircle()}
            </div>
            {!idValid && !evaluationComplete ? (
              <Portrait
                style={{ position: "relative", top: -120, margin: "auto" }}
              />
            ) : (
              <Fade
                show={!idValid && !evaluationComplete}
                hideOnly
                duration={0.8}
                className="h-0"
              >
                <Portrait
                  className="fadeOut"
                  style={{ position: "relative", top: -120, margin: "auto" }}
                />
              </Fade>
            )}
            <Fade show={idValid || evaluationComplete} duration={1.2}>
              <CheckmarkLight
                style={{
                  position: "relative",
                  top: -130,
                  margin: "auto",
                  height: 100,
                  width: 100
                }}
              />
            </Fade>
          </div>
          {error && (
            <div style={{ color: "red", position: "relative", top: 10 }}>
              {error}
            </div>
          )}

          {!idValid && !evaluationComplete && (
            <div className="textContainer" style={{ maxWidth: 240 }}>
              <span>Please wait while we process your identity</span>
            </div>
          )}
          {(idValid || evaluationComplete) && (
            <a onClick={handleNext}>
              <input
                type="button"
                name="button"
                value="Continue"
                disabled={this.state.transitioning}
                className="continueButton cursor-pointer"
              />
            </a>
          )}
        </div>

        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText">
            <div>
              <div>
                <input
                  type="button"
                  name="button"
                  value="Cancel"
                  className="backButton"
                  onClick={() => {
                    window.alert(
                      "You must wait for the current process to finish"
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderProgressCircle = () => {
    return (
      <div class="progress">
        <svg
          class="progress-circle"
          width="200px"
          height="200px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="progress-circle-back" cx="80" cy="80" r="74"></circle>
          <circle
            class="progress-circle-prog"
            ref={this.progressRef}
            style={{
              strokeDasharray: `${(this.props.percentage || 0) * 4.65} 999`
            }}
            cx="80"
            cy="80"
            r="74"
          ></circle>
        </svg>
      </div>
    );
  };

  renderSuccess = () => {
    const {
      step: { error }
    } = this.props;
    const { handlePrevious, handleNext } = this;
    track("ONBOARDING_IDENTITY_STEP_COMPLETE_SUCCESS");

    return (
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
          <div className="stepDescriptionText">
            Yay! Looks like it's really you.
          </div>
          <div style={{ margin: "0 auto" }}>{this.renderProgressCircle()}</div>
          <Fade show={false} hideOnly duration={0.8} className="h-0">
            <Portrait
              className="fadeOut"
              style={{ position: "relative", top: -120, margin: "auto" }}
            />
          </Fade>
          <Fade show duration={1.2}>
            <CheckmarkLight
              style={{
                position: "relative",
                top: -130,
                margin: "auto",
                height: 100,
                width: 100
              }}
            />
          </Fade>
          {/*
            <div>
            <CheckmarkLarge style={{ margin: "0 auto" }} />
          </div>
          */}
          {error && (
            <div style={{ color: "red", position: "relative", top: 10 }}>
              {error}
            </div>
          )}
          <a onClick={handleNext}>
            <input
              type="button"
              name="button"
              value="Continue"
              className="continueButton"
            />
          </a>
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText">
            <div>
              <div onClick={handlePrevious}>
                <Back className="backButtonIcon" />
                <input
                  type="button"
                  name="button"
                  value="Back"
                  className="backButton"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderThanks = () => {
    
    // This component is no longer necessary but keeping it here for consistancy
    return null;
       
  };

  renderFailure = () => {
    const {
      setShowIdTips,
      verifyId: { error: verifyIdError, type } = {}
    } = this.props;
    const { handlePrevious } = this;
    console.log("verify id error", verifyIdError, type);

    return (
      <div
        className="outerStack-mobile sm:outerStack"
        style={{ marginBottom: 88 }}
      >
        {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
        <div className="stepDescriptionText">Oops!</div>
        <div style={{ maxHeight: 220 }}>
          <SadFace style={{ margin: "0 auto" }} />
        </div>
        {/*{error && (
          <div style={{ color: "red", position: "relative", top: 10 }}>
            {error}
          </div>
        )}*/}
        <div className="innerStack">
          <div className="textContainer" style={{ marginTop: 20 }}>
            <span>
              {`${verifyIdError ||
                "Looks like there was an issue verifying your identity."} If the issue
              persists, please `}
            </span>
            <a href={contactUrl} style={{ color: "#28EBC1" }}>
              contact us
            </a>
            .
          </div>
          <a
            onClick={() => {
              setShowIdTips(true);
              handlePrevious(true, type === "ssn");
            }}
          >
            <input
              type="button"
              name="button"
              value="Try Again"
              className="continueButton"
            />
          </a>
          <div className="bottomBar">
            <div className="bottomBarText-mobile sm:bottomBarText">
              <div>
                <div>
                  <input
                    type="button"
                    name="button"
                    value="Back"
                    className="backButton"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      renderProcessing,
      renderSuccess,
      renderFailure,
      renderThanks
    } = this;
    const { idValid, idNeedsReview, step: { error } = {} } = this.props;
    
    return (
      /*renderSuccess()*/
      idNeedsReview
        ? renderProcessing()
        : idValid !== null
        ? idValid
          ? renderProcessing()
          : error
          ? renderFailure()
          : renderThanks()
        : renderProcessing()
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.processingId,
    idValid: state.register.idValid,
    idNeedsReview: state.register.idNeedsReview,
    verifyId: state.register.verifyId,
    percentage: state.register.verificationProgress.percentage,
    duration: state.register.verificationProgress.duration,
    time: state.register.verificationProgress.time
  }),
  actions
)(ProcessingIdentity);
